module.exports = __webpack_public_path__ + "img/logo-jxrlzy.0b076612.png";